export default function OfertaEspecial() {
  const handleComprar = () => {
    window.open('https://pay.hotmart.com/N103806624M', '_blank');
  };

  return (
    <section id="oferta-especial" className="relative py-24 bg-gradient-to-b from-black via-orange-950/20 to-black">
      <div className="max-w-5xl mx-auto px-6">
        {/* Badge */}
        <div className="flex justify-center mb-8">
          <div className="inline-flex items-center gap-3 bg-orange-500 px-8 py-3 animate-pulse">
            <i className="ri-fire-fill text-2xl text-black"></i>
            <span className="text-xl font-black text-black uppercase tracking-wider">
              Oferta por Tempo Limitado
            </span>
            <i className="ri-fire-fill text-2xl text-black"></i>
          </div>
        </div>

        {/* Main Card */}
        <div className="bg-zinc-950 border-4 border-orange-500 p-12 md:p-16 text-center shadow-2xl">
          {/* Price */}
          <div className="mb-8">
            <div className="flex items-center justify-center gap-4 mb-4">
              <span className="text-2xl text-gray-500 line-through">R$ 199,90</span>
              <div className="bg-red-600 px-4 py-1">
                <span className="text-lg font-black text-white">-66% OFF</span>
              </div>
            </div>
            <div className="flex items-baseline justify-center gap-2">
              <span className="text-3xl text-orange-500 font-bold">R$</span>
              <span className="text-7xl md:text-8xl font-black text-orange-500">67</span>
              <span className="text-3xl text-orange-500 font-bold">,90</span>
            </div>
            <p className="text-lg text-gray-400 mt-4">
              Pagamento único • Acesso vitalício
            </p>
          </div>

          {/* Features List */}
          <div className="max-w-md mx-auto mb-10 space-y-4">
            {[
              '174 captures profissionais',
              'Download imediato',
              'Compatível com Ampero II Stage, MP350 e Stomp II'
            ].map((feature, index) => (
              <div key={index} className="flex items-center gap-3 text-left">
                <div className="w-6 h-6 flex items-center justify-center bg-orange-500 flex-shrink-0">
                  <i className="ri-check-line text-lg text-black font-bold"></i>
                </div>
                <span className="text-lg text-white">{feature}</span>
              </div>
            ))}
          </div>

          {/* CTA Button */}
          <button
            onClick={handleComprar}
            className="group relative inline-flex items-center justify-center w-full max-w-md px-12 py-6 text-2xl font-black text-black bg-orange-500 hover:bg-orange-600 transition-all duration-300 transform hover:scale-105 shadow-2xl mb-6 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-shopping-cart-fill mr-3 text-3xl"></i>
            COMPRAR AGORA
          </button>

          <div className="flex items-center justify-center gap-6 text-sm text-gray-400">
            <div className="flex items-center gap-2">
              <i className="ri-lock-fill text-lg text-green-500"></i>
              <span>Pagamento Seguro</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-download-cloud-fill text-lg text-green-500"></i>
              <span>Download Imediato</span>
            </div>
          </div>
        </div>

        {/* Guarantee */}
        <div className="mt-12 text-center">
          <div className="inline-flex items-center gap-3 bg-zinc-950 border border-zinc-800 px-8 py-4">
            <i className="ri-shield-check-fill text-3xl text-green-500"></i>
            <div className="text-left">
              <h3 className="text-lg font-bold text-white">Garantia de 7 dias</h3>
              <p className="text-sm text-gray-400">100% do seu dinheiro de volta se não gostar</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
